module.exports = __webpack_public_path__ + "static/media/ScanRate.1723dd4b.svg";